import { Component } from '@theme/component';
import { ThemeEvents } from '@theme/events';
import { morph } from '@theme/morph';

class VariantMetaobjectRenderer extends Component {
  connectedCallback() {
    super.connectedCallback();
    const section = this.closest('.shopify-section, dialog');
    if (!section) return;
    section.addEventListener(ThemeEvents.variantUpdate, this.#onVariantUpdate);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    const section = this.closest('.shopify-section, dialog');
    if (!section) return;
    section.removeEventListener(ThemeEvents.variantUpdate, this.#onVariantUpdate);
  }

  #onVariantUpdate = (event) => {
    if (event.detail.data.newProduct) {
      this.dataset.productId = event.detail.data.newProduct.id;
    } else if (
      event.target instanceof HTMLElement &&
      event.target.dataset.productId !== this.dataset.productId
    ) {
      return;
    }

    const updated = event.detail.data.html.querySelector(
      `variant-metaobject-renderer[data-block-id="${this.dataset.blockId}"]`
    );

    if (!updated) return;
    morph(this, updated, { childrenOnly: true });
  };
}

if (!customElements.get('variant-metaobject-renderer')) {
  customElements.define('variant-metaobject-renderer', VariantMetaobjectRenderer);
}
